import React from 'react';

import ProfilePlaceHolder from './ProfilePlaceHolder';
import SpotAttendeeInfo from './SpotAttendeeInfo';
import { dedupeArray } from './../../../utils/';

const  ParkingSpotInfoDetail = ({ attendees }) => {
  // Dedupe attendees by vehicle number, class, and attendee id that are rendering multiple times
  const dedupedAttendees = dedupeArray(attendees, ['vehicleNumber', 'class', 'uidAttendee']);

  const attendeesList = dedupedAttendees.map((attendee, index) => {
    return <SpotAttendeeInfo key={`${attendee.uidAttendee}-${index}`} attendee={attendee} />;
  });

  return (
    <div className="spot-details">
      { dedupedAttendees.length ? attendeesList : <ProfilePlaceHolder /> }
    </div>
  );
};

export default ParkingSpotInfoDetail;



// WEBPACK FOOTER //
// ./src/components/MapInfoBar/ParkingSpotInfoDetail/index.js